import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralize } from "@common/helpers/string";
import { useDocumentCategoryLabel } from "@api/documentCategory.api";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface DocumentCategoriesFilterLabelProps {
    filters: Pick<FiltersTypes, "documentCategoryIds">;
}

export const DocumentCategoriesFilterLabel: React.FC<
    DocumentCategoriesFilterLabelProps
> = ({ filters: { documentCategoryIds } }) => {
    const singleLabel = useDocumentCategoryLabel(
        documentCategoryIds?.length === 1 ? documentCategoryIds : undefined,
    );

    if (singleLabel) {
        return <BreakableText text={singleLabel} />;
    }

    const totalCount = documentCategoryIds?.length ?? 0;

    return (
        <>
            {totalCount} document {pluralize("type", totalCount)}
        </>
    );
};
